import { useApiContext, useGetFullInfo } from 'react-easyrocket';
import { useModalContext } from './useModalContext';
import { useEffect } from 'react';
import { isShowEventModal } from 'src/config/event/utils';

export function useOpenEventModal() {
  const { isAuthenticated } = useApiContext();
  const { fullInfo } = useGetFullInfo();
  const { openModal } = useModalContext();

  useEffect(() => {
    const { shouldShowModal, day, fullDate } = isShowEventModal();

    if (isAuthenticated && fullInfo?.level > 0 && shouldShowModal) {
      return openModal('EVENT_MODAL', { props: { day, fullDate } });
    }
  }, [fullInfo?.level, isAuthenticated, openModal]);
}
